import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'
import { Text } from '../../../Text'

export const TableItemsAmountSelectWrapper = styled.div`
  display: flex;
  align-items: center;
`

// TODO retheming 2026 - get rid of (Text), which is an antipattern
export const TableItemsAmountSelectLabel = styled(Text)`
  flex-shrink: 0;
  margin-left: ${Spacing.S8};
`

export const SelectWrapper = styled.div`
  max-width: 74px;
`
